<template>
  <div id="app">
    <NetworkStatusBanner />
    <router-view></router-view>
  </div>
</template>

<script>
import NetworkStatusBanner from "@/components/widgets/NetworkStatusBanner.vue";

export default {
  name: "App",
  components: { NetworkStatusBanner },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
